import { FC, useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";

import ServiceTabMenu from "../../../common/pos/service-tab-menu/service-tab-menu";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import DryClean from "./dry-clean/dry-clean";
import Alteration from "./alteration/alteration";
import Laundry from "./laundry/laundry";
import Costume from "./costume/costume";
import Household from "./household/household";
import Leather from "./leather/leather";
import { CartSliceAction } from "../../../../redux/slice/cartSlice";
import { Colors } from "../../../../configs";

export interface IServicesProps {}

const ServiceComponent: FC<IServicesProps> = () => {
  const { selectedServiceType } = useAppSelector((state) => state.cart);
  const sanitizedCategoryName = useMemo(() => {
    // remove all unreadable characters and new lines and etc
    return selectedServiceType?.categoryName?.replace(/[^\x20-\x7E]/g, "").trim();
  }, [ selectedServiceType?.categoryName ]);

  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   if (selectedServiceType?.categoryName != "Dry Clean") {
  //     dispatch(
  //       CartSliceAction.setSelectedServiceType({
  //         categoryName: "Dry Clean",
  //         categoryCode: "DC",
  //         id: 142,
  //         orderIndex: null,
  //         showInMenu: true,
  //       })
  //     );
  //   }
  // }, []);

  return (
    <>
      <Box
        sx={{
          flex: 5,
          display: "flex",
          flexDirection: "column",
          gap: "1.42857143rem",
        }}
      >
        <Typography sx={{ fontSize: "2.57rem", color: Colors.TEXT_GRAY_DARK }}>
          Add Items
        </Typography>

        <ServiceTabMenu
          currentTab={sanitizedCategoryName || "Dry Clean"}
        />

        {/* Dry Clean Tab */}
        {sanitizedCategoryName === "Dry Clean" && <DryClean />}

        {/* Launtry Tab */}
        {sanitizedCategoryName === "Laundry" && <Laundry />}

        {/* Costume */}
        {sanitizedCategoryName === "Costumes" && <Costume />}

        {/* Household */}
        {sanitizedCategoryName === "Household" && <Household />}

        {/* Leather */}
        {sanitizedCategoryName === "Leather" && <Leather />}

        {/* Alteration Tab */}
        {sanitizedCategoryName === "Alteration" && <Alteration />}
      </Box>
    </>
  );
};

export default ServiceComponent;
